module.exports = __webpack_public_path__ + "static/img/01.254ec021.png";